import { de, type Translations } from './de.js'

/**
 * Minimal translation lookup.
 *
 * German is the only locale for now, but nothing in the components knows that —
 * they call `t()` and never hold a literal. Swapping in a real i18n library
 * later is a change to this file alone.
 */
const locales = { de } as const

export type Locale = keyof typeof locales

let activeLocale: Locale = 'de'

export function setLocale(locale: Locale): void {
  activeLocale = locale
}

export function t(): Translations {
  return locales[activeLocale]
}

/**
 * Substitutes `{name}`-style placeholders.
 *
 * Kept separate from `t()` so the string table stays plain data and a
 * placeholder that is never filled shows up as itself rather than as an empty
 * gap nobody notices.
 */
export function format(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in values ? String(values[key]) : match,
  )
}
